import * as ko from "knockout";
import * as $ from "jquery";
import "jsignature";
ko.bindingHandlers.sign = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        $(element).jSignature();
        var fnName = valueAccessor();
        
        if(viewModel["signitureInitialized"] != null && typeof viewModel["signitureInitialized"] === "function"){
            viewModel.signitureInitialized($(element));
        }

        if (viewModel[fnName] != null && typeof viewModel[fnName] === "function") {
            viewModel[fnName] = function (command, args) {
                return $(element).jSignature(command, args);
            };
        }
    }
};